if (!customElements.get('kan-progress')) {
  customElements.define('kan-progress', class extends HTMLElement {
    constructor() {
      super();
      this.frame = null;
      this.unlocked = false;
      this.update = () => {
        this.frame = null;
        const scope = this.closest('main') || document;
        const deal = scope.querySelector('.kan-offer__card');
        if (!deal) return;
        const target = Math.max(window.scrollY + deal.getBoundingClientRect().top - window.innerHeight / 2, 1);
        const progress = Math.min(Math.max(window.scrollY / target, 0), 1);
        if (!this.unlocked && progress >= 1) {
          this.unlocked = true;
          this.setAttribute('data-unlocked', '');
          this.querySelector('.kan-progress__label').textContent = this.dataset.unlockedLabel;
        }
        const value = this.unlocked ? 1 : 0.05 + 0.95 * progress;
        this.style.setProperty('--kan-progress', value);
        this.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', Math.round(value * 100));
      };
      this.queueUpdate = () => {
        if (this.frame === null) this.frame = requestAnimationFrame(this.update);
      };
    }

    connectedCallback() {
      window.addEventListener('scroll', this.queueUpdate, { passive: true });
      window.addEventListener('resize', this.queueUpdate);
      window.addEventListener('pageshow', this.queueUpdate);
      document.addEventListener('shopify:section:load', this.queueUpdate);
      document.addEventListener('shopify:section:unload', this.queueUpdate);
      this.resizeObserver = new ResizeObserver(this.queueUpdate);
      this.resizeObserver.observe(this.closest('main') || document.body);
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.queueUpdate);
      window.removeEventListener('resize', this.queueUpdate);
      window.removeEventListener('pageshow', this.queueUpdate);
      document.removeEventListener('shopify:section:load', this.queueUpdate);
      document.removeEventListener('shopify:section:unload', this.queueUpdate);
      this.resizeObserver.disconnect();
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}
